import { render, staticRenderFns } from "./TeacherMain.vue?vue&type=template&id=626f97e8&"
import script from "./TeacherMain.vue?vue&type=script&lang=js&"
export * from "./TeacherMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports